import { Api } from 'core/api';

const getSlugsOptions = (title: string) => {
  const props = {
    options: {
      method: 'GET',
    },
    url: `/slugs?title=${title}`,
  };

  const slugs = new Api(props).simpleFetch();
  return slugs;
};

export { getSlugsOptions };
